import { Molecule } from 'openchemlib/full';
export async function readSMILES(file, options = {}) {
    const result = {
        molecules: [],
        spectra: [],
    };
    const smilesList = (await file.text())
        .split(/\r?\n/)
        .filter((entry) => entry);
    for (const smiles of smilesList) {
        const molecule = Molecule.fromSmiles(smiles);
        molecule.addImplicitHydrogens();
        const molfile = molecule.toMolfile();
        result.molecules.push({ molfile });
    }
    options.logger?.info(`Found ${result.molecules.length} molecules from the ${file.name} file`);
    return result;
}
//# sourceMappingURL=readSMILES.js.map